import Head from 'next/head';
import { organization } from 'lib/seo/constants';

interface IProductSchemaProps {
  url: string;
  title: string;
  imageUrl: string;
  description: string;
}

export default function ProductSchema({ url, title, imageUrl, description }: IProductSchemaProps) {
  const schemaProduct = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    '@id': url,
    name: title,
    image: [imageUrl],
    description: description,
    brand: {
      '@type': 'Brand',
      name: organization,
    },
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaProduct) }}
      />
    </Head>
  );
}
